import { base64StringToBlob } from "blob-util";
import { SPECIFIC_WEB_STORE, WEB_STORE_AMOUNT_TYPE } from "./constant";
import { logServiceSend } from "../landing/helper";
import logService from "../logService";
const LOG_API = "https://clog.affilio.ir/1DpjBLHYdgacVMi/lg";
// const LOG_API = "http://localhost:8082/log_view";

export const getUrlFile = (data) => {
  const { source: b64, user_defined_name: fileName, mime_type: mType } = data;
  const blob = base64StringToBlob(b64, mType);
  const url = window.URL.createObjectURL(blob);
  return url;
};

const detectBaseUrl = () => {
  const host = window.location.hostname;
  // UN COMMENT FOT TEST
  // if (host === "localhost:3030") {
  //   return "http://localhost:8080";
  // } else
  if (host === "stage.affilio.ir") {
    return "https://widget-stage.affilio.ir";
  } else {
    return "https://widget.affilio.ir";
  }
};

export const getUrl = (type, pth) => {
  try {
    if (type === "asset") {
      const baseUrl = detectBaseUrl();
      const assetsUrl = `${baseUrl}/assets/${pth}`;
      return assetsUrl;
    }
    return "";
  } catch (e) {
    // console.log("error", e);
    return "";
  }
};

export const getUrlImage = (product) => {
  if (product.web_store_id === SPECIFIC_WEB_STORE.DIGIKALA) {
    return `${product?.profile_image_path}?x-oss-process=image/resize,m_lfit,h_300,w_300/quality,q_90`;
  }
  return product?.profile_image_path;
};

export const priceFormat = (price) => {
  return price;
};

export const formatDiscount = (price) => {
  try {
    // return `${Math.round((price.discount / price.amount) * 100)}%`;
    if (price.amount_type === WEB_STORE_AMOUNT_TYPE.OriginalAmount) {
      if ((price.discount / price.amount) * 100 > 1) {
        return `${((price.discount / price.amount) * 100).toFixed(1)}%`;
      }
    } else if (price.amount_type === WEB_STORE_AMOUNT_TYPE.AmountWithDiscount) {
      if ((price.discount / (price.amount + price.discount)) * 100 > 1) {
        return `${(
          (price.discount / (price.amount + price.discount)) *
          100
        ).toFixed(1)}%`;
      }
    }
    return "~1%";
  } catch (e) {
    return 0;
  }
};

const DIC = {
  show_product: "مشاهده محصول",
  show_product_in: "خرید از",
  filter_title: "دسته بندی ها",
  search: "جستجو",
  searchText: "جستجو ...",
  newest: "جدیدترین",
  oldest: "قدیمی ترین",
  most_discount: "پرتخفیف ترین",
  cheapest: "ارزانترین",
  expensive: "گرانترین",
  grid_view: "نمایش جدولی",
  list_view: "نمایش لیست",
  notFound: "با عرض پوزش، نتیجه‌ای یافت نشد!",
  notFoundText:
    "از عبارت‌های متداول‌تر استفاده کنید و یا املای عبارت وارد‌شده را بررسی کنید.",
  errorText: "خطای ",
  notFoundText2:
    "خطای شبکه، لطفا اتصال اینترنت خود را چک کرده و مجددا تلاش کنید",
  range_price: "محدوده قیمت",
  toman: "تومان",
  from: "از",
  to: "تا",
  total_found: "تعداد نتایج:",
  filtering: "فیلترها",
  apply_filters: "اعمال فیلترها",
};

export const t = (key) => {
  return DIC[key] || key;
};

export const debounce = (func, wait, immediate) => {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

export const setRemoteLog = (data) => {
  const mainBody = {
    type: "info",
    eventType: data?.eventType || "WIDGET_VIEW",
    data: data,
    website: data?.url,
    website_path: data?.url_path,
  };
  logService.send(mainBody);
};
